import { type PrivilegeTableProps } from '@/app/lcv/types/calculator';

export const CALCULATOR_METADATA = {
  title: 'คำนวณค่างวด',
  description:
    'เลือกรถรุ่นที่คุณสนใจและลองคำนวณค่างวดที่ต้องจ่ายรุ่นแบบละเอียด',
  url: '/calculator',
};

export const DMAX_DATA: PrivilegeTableProps = {
  title: 'สิทธิพิเศษเมื่อซื้อรถ ออลนิว อีซูซุดีแมคซ์',
  coupon: {
    description: '800 บาท จำนวน 5 ครั้ง',
    price: '4,000 บาท',
  },
  myMember: {
    cta: '/privileges/my-member',
  },
  isp: {
    mileage: 'เพิ่มเป็น 5 ปี / 160,000 กม.',
    price: '7,000 บาท',
  },
};

export const MUX_DATA: PrivilegeTableProps = {
  title: 'สิทธิพิเศษเมื่อซื้อรถ อีซูซุมิว-เอ็กซ์',
  coupon: {
    description: '800 บาท จำนวน 10 ครั้ง',
    price: '8,000 บาท',
  },
  myMember: {
    cta: '/privileges/my-member',
  },
  isp: {
    mileage: 'เพิ่มเป็น 5 ปี / 160,000 กม.',
    price: '8,000 บาท',
  },
};
